import { reactToCwp } from '../../../common/react-utils'
import Register from './Register'

export default reactToCwp(Register)